import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, inventoriesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, inventoriesActions);

export default slice.reducer;
